import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import { Checkbox, Button as GridButton } from '../../../../Components/MUIs';
import { PolBasic02DatalistTextCellEditor } from './POL_BASIC_02_DatalistTextCellEditor';

export const getColumnDefs1 = (props) => {
  const getUniqueValuesFromGrid = (field, currentValue = '') => {
    const values = new Set();
    const gridApi = props.gridRef1?.current?.api;

    if (gridApi) {
      gridApi.forEachNode((node) => {
        const row = node?.data;
        if (!row || row?.deleteYn === 'Y') return;
        const value = String(row?.[field] ?? '').trim();
        if (!value) return;
        values.add(value);
      });
    } else {
      (props.rowData1 || []).forEach((row) => {
        if (!row || row?.deleteYn === 'Y') return;
        const value = String(row?.[field] ?? '').trim();
        if (!value) return;
        values.add(value);
      });
    }

    const current = String(currentValue ?? '').trim();
    if (current) values.add(current);

    return Array.from(values);
  };

  return [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      cellClass: 'delete-action-cell',
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection,
      },
    }),

    CreateColumn('chaebun', '채번', 'center', 100, false, false, true),
    CreateColumn('seq', '순번', 'right', 50, false, false, true),

    CreateColumn('gubun', '구분', 'left', 250, true, true, false, 'text', {
      maxLength: 100,
      cellEditor: PolBasic02DatalistTextCellEditor,
      cellEditorParams: (params) => ({
        maxLength: 100,
        getSuggestions: () =>
          getUniqueValuesFromGrid('gubun', params?.value),
      }),
    }),

    CreateColumn(
      'gubun2',
      '세부목표',
      'left',
      250,
      true,
      false,
      false,
      'text',
      {
        maxLength: 150,
        cellEditor: PolBasic02DatalistTextCellEditor,
        cellEditorParams: (params) => ({
          maxLength: 150,
          getSuggestions: () =>
            getUniqueValuesFromGrid('gubun2', params?.value),
        }),
      }
    ),

    {
      headerName: '1분기',
      headerClass: 'ag-center-header',
      children: [
        CreateColumn(
          'planQuarter1',
          '계획',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
        CreateColumn(
          'performanceQuarter1',
          '실적',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
      ],
    },
    {
      headerName: '2분기',
      headerClass: 'ag-center-header',
      children: [
        CreateColumn(
          'planQuarter2',
          '계획',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
        CreateColumn(
          'performanceQuarter2',
          '실적',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
      ],
    },
    {
      headerName: '3분기',
      headerClass: 'ag-center-header',
      children: [
        CreateColumn(
          'planQuarter3',
          '계획',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
        CreateColumn(
          'performanceQuarter3',
          '실적',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
      ],
    },
    {
      headerName: '4분기',
      headerClass: 'ag-center-header',
      children: [
        CreateColumn(
          'planQuarter4',
          '계획',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
        CreateColumn(
          'performanceQuarter4',
          '실적',
          'center',
          80,
          false,
          false,
          false,
          'custom',
          {
            cellRenderer: (params) => (
              <Checkbox
                name=""
                checked={params.value === 'Y'}
                onChange={(change) => params.setValue(change ? 'Y' : 'N')}
                nameSx={{ m: 0 }}
              />
            ),
          }
        ),
      ],
    },

    CreateColumn(
      'target',
      '목표 및 성과지표',
      'left',
      150,
      true,
      false,
      false,
      'text',
      { maxLength: 150 }
    ),
    CreateColumn(
      'department',
      '부서(담당자)',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        maxLength: 20,
        headerComponentParams: {
          template:
            '<div class="ag-header-cell-label"><span>부서<br>(담당자)</span></div>',
        },
      }
    ),

    CreateColumn(
      'percent',
      '달성률(%)',
      'right',
      130,
      true,
      false,
      false,
      'number',
      {
        maxLength: 4,
        valueFormatter: (params) => params.value ?? '',
      }
    ),

    CreateColumn(
      'performance',
      '실적/부진사유',
      'left',
      280,
      true,
      false,
      false,
      'text',
      { maxLength: 100 }
    ),
    CreateColumn('remark', '비고', 'left', 280, true, false, false, 'text', {
      maxLength: 100,
    }),

    CreateColumn(
      'upload',
      '파일 업로드',
      'center',
      100,
      false,
      false,
      false,
      'custom',
      {
        headerComponentParams: {
          template:
            '<div class="ag-header-cell-label"><span>파일<br>업로드</span></div>',
        },
        cellRenderer: (e) => (
          <GridButton
            size="small"
            name={e.data?.fileName ? '파일보기' : '업로드'}
            variant={e.data?.fileName ? 'outlined' : 'contained'}
            sx={{ width: '100%', fontSize: '0.8rem' }}
            onClick={() => props.PopupFileClickEvent?.(e.data)}
          />
        ),
      }
    ),
    CreateColumn(
      'fileName',
      '파일명',
      'left',
      300,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
      }
    ),

    // FileUploadDialog(공통) 호환 필드들 (다른 화면과 동일한 camelCase 기준)
    CreateColumn('saveName', 'saveName', 'left', 150, false, false, true),
    CreateColumn('filePath', 'filePath', 'left', 150, false, false, true),
    CreateColumn(
      'previewFilePath',
      'previewFilePath',
      'left',
      150,
      false,
      false,
      true,
      'text'
    ),
    // 기타 숨김 필드
    CreateColumn('mapBlob', 'mapBlob', 'left', 150, false, false, true),
    CreateColumn('mapFile', 'mapFile', 'left', 150, false, false, true),
    CreateColumn('mapFileName', 'mapFileName', 'left', 150, false, false, true),
    CreateColumn('createId', 'createId', 'left', 150, false, false, true),
    CreateColumn('createDate', 'createDate', 'center', 150, false, false, true),
    CreateColumn('updateId', 'updateId', 'left', 150, false, false, true),
    CreateColumn('updateDate', 'updateDate', 'center', 150, false, false, true),
  ];
};
const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
